export class DetectorTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<DetectorType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<DetectorType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DetectorTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
